import { cacheDom } from "../utils/QuerySelectors.js"
import { videoHtml } from "../utils/helpers.js"

const dom = {}
const qs = {
  video: 'data-hp-video',
  videoMobile: 'data-hp-video-mobile',
  preload: 'data-video-preload',
}
const qsAll = {
  sections: 'data-section-type="hero"',
}

const initSection = (section) => {
  window.addEventListener('load', () => {
    const preload = section.querySelector(`[${qs.preload}]`)
    if(preload) {
      const videoJson = section.querySelector(`[${qs.video}]`) ? JSON.parse(section.querySelector(`[${qs.video}]`).innerHTML) : null
      const videoMobileJson = section.querySelector(`[${qs.videoMobile}]`) ? JSON.parse(section.querySelector(`[${qs.videoMobile}]`).innerHTML) : null
      if(videoJson) {
        section.innerHTML = videoHtml(videoJson, 'hero-media', true) + section.innerHTML
      }
      if(videoMobileJson) {
        section.innerHTML = videoHtml(videoMobileJson, 'hero-media hero-media--mobile') + section.innerHTML
      }
      // preload.remove()
    }
  })
}

export const setupHeros = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}